import { NgClass, NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';

@Component({
  standalone: true,
  selector: 'lx-form-field-lite',
  imports: [NgClass, NgIf],
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent implements OnInit {
  @Input() label = '';
  @Input() subLabel = '';
  @Input() control: AbstractControl | undefined;

  errorMessage = '';
  valid = false;
  invalid = false;
  required = false;

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    combineLatest([this.control?.valueChanges || [], this.control?.statusChanges || []])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.updateView();
      });
    this.updateView();
  }

  private updateView(): void {
    if (!this.control) {
      return;
    }

    const errors = this.control.errors;
    this.valid = this.control.valid;
    this.invalid = this.control.invalid;
    this.required = this.control.hasValidator(Validators.required);

    if (!errors) {
      this.errorMessage = '';
      return;
    }

    // First check if the 'required' error is present
    if (errors['required']) {
      this.errorMessage = $localize`This question is required`;
      return;
    }

    // Otherwise, check for custom error messages in the errors object
    this.errorMessage = Object.values(errors).find((error) => error?.message)?.message ?? '';
  }
}
